import type { Tool, ToolContext } from "./Tool";

/**
 * One-shot tool that opens the "Import image" modal on activation. No pointer
 * handling — once the modal is up, interaction happens inside it, not on the
 * scene. The tool stays selected until the user picks another, which reads as
 * "you're in import mode right now."
 */
export class ImportTool implements Tool {
  readonly id = "import";
  readonly name = "Import";
  readonly hint = "Upload an image to auto-trace it into neon tubes.";
  readonly icon = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="4" width="18" height="14" rx="2" />
      <path d="M3 15l5-5 4 4 3-3 6 6" />
      <circle cx="16" cy="9" r="1.4" fill="currentColor" />
    </svg>`;

  onActivate(ctx: ToolContext): void {
    ctx.openImport();
  }
}
